import './sitemap-nav.scss';

class SitemapNav {
    constructor (element) {
        this.$nav = element;
        this.$toggles = this.$nav.querySelectorAll('.sitemap-nav__toggle[data-nav="toggle"]');
        this.initialize();
    }

    initialize () {
        this.$toggles.forEach($toggle => {
            $toggle.addEventListener('click', () => {
                const isOpen = $toggle.getAttribute('aria-expanded') === 'true';
                $toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            });
        });
    }
}

export default SitemapNav;

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context === document) {
        const $sitemapNav = document.querySelector('[data-nav="sitemap-nav--level-1"]');
        if ($sitemapNav) {
            $sitemapNav.API = new SitemapNav($sitemapNav);
        }
    }
});
